module.exports = __webpack_public_path__ + "static/media/simulation-select-percent-icon.f7664fca.svg";